import { render, staticRenderFns } from "./TestMode.vue?vue&type=template&id=9821ce06&scoped=true&"
import script from "./TestMode.vue?vue&type=script&lang=js&"
export * from "./TestMode.vue?vue&type=script&lang=js&"
import style0 from "./TestMode.vue?vue&type=style&index=0&id=9821ce06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9821ce06",
  null
  
)

export default component.exports